<template>
  <div class="c-app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="p-4 text-center">
            <img
              class="mb-4 rounded-circle"
              src="/img/logo.jpg"
              alt=""
              height="72"
            />
            <p class="text-muted small">
              <b>ScanCom Portal</b>
            </p>
            <h4>Forgot Password</h4>
            <div class="box-body">
              <label for="resetEmail">Account Email:</label>
              <input
                id="resetEmail"
                ref="first"
                placeholder="Enter your Email"
                type="email"
                v-model="email"
                @focus="clearStatus"
                :class="{
                  'has-error': submitting && !validEmail,
                  'form-control mt-2': true,
                }"
              />
              <p v-if="error && submitting" class="error-message">
                {{ message }}
              </p>
              <p v-else class="text-muted small">
                Enter your email to get reset code.
              </p>
            </div>

            <div class="box-footer">
              <router-link class="returnLogin" :to="{ name: 'Login' }"
                >Login page
              </router-link>
              <div class="text-center" v-if="submitting">
                <div class="spinner-border text-info" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <button
                type="button"
                class="modal-default-button btn btn-sm btn-primary"
                v-else
                @click="nextStep"
              >
                Get code
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmCodeModal
      :email="email"
      v-if="showConfirmCodeModal"
      @close="showConfirmCodeModal = false"
    />
  </div>
</template>

<script>
import ConfirmCodeModal from "@/views/forgotPassword/ConfirmCodeModal.vue";

export default {
  name: "ForgotPassword",
  components: {
    ConfirmCodeModal,
  },
  data() {
    return {
      showConfirmCodeModal: false,
      submitting: false,
      error: false,
      message: "",
      email: "",
    };
  },
  computed: {
    validEmail() {
      if (/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async nextStep() {
      this.submitting = true;
      if (this.email === "") {
        (this.message = "❗ Email is required"), (this.error = true);
        return;
      }
      if (!this.validEmail) {
        (this.message = "❗ Email is not valid"), (this.error = true);
        return;
      }

      const resp = await this.$http
        .post("/api/auth/getcode", {
          email: this.email,
          code: "",
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            text: err,
          });
          this.submitting = false;
        });

      if (resp.data.status == this.$const.RESPONSE_TYPES.Success) {
        this.showConfirmCodeModal = true;
        localStorage.userAccount = JSON.stringify({
          email: this.email,
          code: "",
        });
      } else {
        this.$swal({ text: "Can not send request" });
      }

      this.message = "";
      this.clearStatus();
    },
    clearStatus() {
      this.error = false;
      this.submitting = false;
    },
  },
};
</script>


<style scoped>
.has-error {
  border: 1px solid #d33c40;
}
.error-message {
  color: #d33c40;
}
.returnLogin {
  margin-right: 20px;
}
.box-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 0;
}
.box-body {
  margin: 10px 0;
  text-align: left;
}
.modal-default-button {
  float: right;
}
</style>

